// extracted by mini-css-extract-plugin
export var callCard = "_q8-0";
export var callMessageButton = "_q8-1";
export var helpIcon = "_q8-3";
export var helpIconContainer = "_q8-4";
export var verticalDivider = "_q8-2";